module.exports = __webpack_public_path__ + "static/img/hcp-seg-brintellix-3.5759e440.png";